import { Doughnut } from "vue-chartjs";

export default {
  extends: Doughnut,
  data() {
    return {
      options: {
        cutoutPercentage: 80,
        responsive: true,
        legend: {
          position: "bottom",
        },
        tooltips: {
          enabled: false,
        },
      },
    };
  },
  props: {
    chartdata: {
      type: Object,
      default: null,
    },
  },
  mounted() {
    this.renderChart(this.chartdata, this.options);
  },
};
